(() => {
  const whatsappNumber = '573003586097';

  const normalize = (value = '') =>
    value
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  const whatsappUrl = (message) => `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  const initCatalog = (scope = document) => {
    const root = scope.querySelector?.('[data-sky300-catalog]');
    if (!root || root.dataset.sky300Ready === 'true') return;
    root.dataset.sky300Ready = 'true';

    const buttons = Array.from(root.querySelectorAll('[data-sky300-catalog-filter]'));
    const search = root.querySelector('[data-sky300-catalog-search]');
    const searchButton = root.querySelector('[data-sky300-catalog-search-button]');
    const status = root.querySelector('[data-sky300-catalog-status]');
    const empty = root.querySelector('[data-sky300-catalog-empty]');
    const emptyWhatsapp = root.querySelector('[data-sky300-catalog-whatsapp]');
    const isEnglish = document.documentElement.lang.toLowerCase().startsWith('en');
    let activeFilter = 'all';

    const applyFilter = ({ shouldScroll = false } = {}) => {
      const items = Array.from(document.querySelectorAll('#product-grid > .grid__item'));
      const rawQuery = search?.value.trim() || '';
      const queryTokens = normalize(rawQuery).split(/\s+/).filter(Boolean);
      let visible = 0;

      items.forEach((item) => {
        const haystack = normalize(
          `${item.dataset.sky300Title || ''} ${item.dataset.sky300Type || ''} ${item.dataset.sky300Tags || ''}`
        );
        const categoryMatches = activeFilter === 'all' || item.dataset.sky300Category === activeFilter;
        const queryMatches = queryTokens.length === 0 || queryTokens.every((token) => haystack.includes(token));
        const matches = categoryMatches && queryMatches;
        item.hidden = !matches;
        if (matches) visible += 1;
      });

      buttons.forEach((button) => {
        const filter = button.dataset.sky300CatalogFilter;
        const active = filter === activeFilter;
        const categoryCount = filter === 'all'
          ? items.length
          : items.filter((item) => item.dataset.sky300Category === filter).length;
        const count = button.querySelector('[data-sky300-category-count]');
        if (count) count.textContent = isEnglish ? `${categoryCount} products` : `${categoryCount} productos`;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (status) {
        if (rawQuery) {
          status.textContent = isEnglish
            ? `${visible} products match “${rawQuery}”. Compatibility must still be confirmed by model, year and engine.`
            : `${visible} productos coinciden con “${rawQuery}”. La compatibilidad todavía debe confirmarse por modelo, año y motor.`;
        } else if (activeFilter === 'all') {
          status.textContent = isEnglish
            ? `Showing the complete catalog: ${visible} products.`
            : `Mostrando el catálogo completo: ${visible} productos.`;
        } else {
          status.textContent = isEnglish
            ? `${visible} products match the selected category.`
            : `${visible} productos corresponden a la categoría seleccionada.`;
        }
      }

      if (empty) empty.hidden = visible !== 0;

      if (emptyWhatsapp && visible === 0) {
        const categoryLabel =
          buttons.find((button) => button.dataset.sky300CatalogFilter === activeFilter)?.textContent.trim() || '';
        const searched = rawQuery || categoryLabel;
        const message = isEnglish
          ? `Hello Sky300 Performance. I could not find “${searched}” in the catalog. My Mazda model is: ____. Year: ____. Engine: ____. I need: ____.`
          : `Hola Sky300 Performance. No encontré “${searched}” en el catálogo. Mi modelo Mazda es: ____. Año: ____. Motor: ____. Necesito: ____.`;
        emptyWhatsapp.href = whatsappUrl(message);
      }

      if (shouldScroll) {
        const target = document.querySelector('.sky300-catalog-grid-title') || document.querySelector('#ProductGridContainer');
        target?.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start',
        });
      }
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.sky300CatalogFilter;
        applyFilter({ shouldScroll: true });
      });
    });

    search?.addEventListener('input', () => applyFilter());
    search?.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      applyFilter({ shouldScroll: true });
    });
    searchButton?.addEventListener('click', () => applyFilter({ shouldScroll: true }));

    applyFilter();
  };

  const initFaq = (scope = document) => {
    const root = scope.querySelector?.('[data-sky300-faq]');
    if (!root || root.dataset.sky300Ready === 'true') return;
    root.dataset.sky300Ready = 'true';

    const buttons = Array.from(root.querySelectorAll('[data-sky300-faq-category]'));
    const items = Array.from(root.querySelectorAll('[data-sky300-faq-item]'));
    let category = 'all';

    const update = () => {
      items.forEach((item) => {
        item.hidden = category !== 'all' && item.dataset.category !== category;
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        category = button.dataset.sky300FaqCategory;
        buttons.forEach((candidate) => {
          const active = candidate === button;
          candidate.classList.toggle('is-active', active);
          candidate.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        update();
      });
    });

    update();
  };

  const init = (scope = document) => {
    initCatalog(scope);
    initFaq(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
